import { DefaultTheme } from 'styled-components';

export const lightTheme: DefaultTheme = {
  bgColor: '#FFFFFF', //'#e6e6fa'
  color000: '#000',
  color222: '#222',
  textDefaultColor: '#333',
  textThinColor: '#555',
  textLightBlick: '#444',
  text666: '#666',
  text777: '#777',
  whiteText: '#FFF',
  logoColor: '#6D28D9',
  borderGrayColor: '#ececec',
  grayColor: '#999999',
  btnColor: '#7C3AED',
  bodyBgColor: '#F9FBFC',//'#f5f5f5',//'#F0F2F5',
  iconColor: '#2c3e50',

  accentColor: '#35266E',
  questionBoxBg: '#f8f9fa',
  resetBtnColor: '#35266D',
  stopBtnColor: '#F8C311',
};

export const darkTheme: DefaultTheme = {
  bgColor: '#1a1a1a',
  color000: '#FFF',
  color222: '#FFF',
  textDefaultColor: '#FFF',
  textThinColor: '#CCC',
  textLightBlick: '#DDD',
  text666: '#BBB',
  text777: '#AAA',
  whiteText: '#000',
  logoColor: '#FFF',
  borderGrayColor: '#333',
  grayColor: '#666',
  btnColor: '#667eea',
  bodyBgColor: '#2a2a2a',
  iconColor: '#FFF',

  accentColor: '#764ba2',
  questionBoxBg: '#2a2a2a',
  resetBtnColor: '#667eea',
  stopBtnColor: '#F8C311',
};

export const theme = lightTheme;
